module.exports = __webpack_public_path__ + "img/invisible-button.004d2251.svg";